import OptimizationStore from "../../../../../modules/optimization/store/OptimizationStore"
import * as keys from "./keys";

class Utils {

  getPremiumTermList = (pptValue, formRef) => {

    let ptList = []

    switch (pptValue) {
      case "5":
        ptList = [{ label: '22', id: '22' }, { label: '27', id: '27' }, { label: '32', id: '32' }, { label: '37', id: '37' }]
        break;

      case "8":
        ptList = [{ label: '20', id: '20' }, { label: '25', id: '25' }, { label: '30', id: '30' }, { label: '35', id: '35' }, { label: '40', id: '40' }]
        break;

      case "10":
        ptList = [{ label: '22', id: '22' }, { label: '27', id: '27' }, { label: '32', id: '32' }, { label: '37', id: '37' }, { label: '42', id: '42' }]
        break;

      case "12":
        ptList = [{ label: '24', id: '24' }, { label: '29', id: '29' }, { label: '34', id: '34' }, { label: '39', id: '39' }, { label: '44', id: '44' }]
        //  ptList = [{label: '24', id: '24'},{label: '29', id: '29'},{label: '34', id: '34'},{label: '39', id: '39'}]
        break;

      default:
        break;
    }

    formRef.$("PT").set("extra", {
      ...formRef.$("PT").extra,
      optionList: ptList,
    });

    const ptValue = formRef.$("PT").value.label

    const ptListArray = new Set(ptList.map((item) => item.label))

    if (ptListArray.has(ptValue)) return
    else formRef.$("PT").set('value', ptList[0])

  }


  updateBi = (key, value, package_id, formRef, productData) => {
    let biData = OptimizationStore.fetchBiRequestForCompareProduct(
      package_id,
      productData?.data?.family_product_id
    );
    let biRequest = biData.data.bi_request;

    switch (key) {
      case keys.PPT:
        biRequest[keys.PPT] = value;
        break;

      case keys.PT:
        biRequest[keys.PT] = value;
        break;

      case keys.LUMPSUM_BENEFIT:
        biRequest[keys.LUMPSUM_BENEFIT] = value;
        break;

      case keys.FREQUENCY:

        biRequest[keys.FREQUENCY] = value.frequency;
        break;

      case keys.WOP_RIDER:
        biRequest[keys.WOP_RIDER] = value;
        break;

      case keys.ADB_RIDER:
        if (value) {
          biRequest[keys.ADB_RIDER] = value;
        } else {
          biRequest[keys.ADB_RIDER] = "";
        }
        break;

      case keys.ATPD_RIDER:
        if (value) {
          biRequest[keys.ATPD_RIDER] = value;
        } else {
          biRequest[keys.ATPD_RIDER] = "";
        }
        break;

      case keys.Critical_ILLNESS_RIDER:
        if (value) {
          biRequest[keys.Critical_ILLNESS_RIDER] = value;
        } else {
          biRequest[keys.Critical_ILLNESS_RIDER] = "";
        }
        break;

      case keys.INCOME_BENEFIT_RIDER:
        if (value) {
          biRequest[keys.INCOME_BENEFIT_RIDER] = value;
        } else {
          biRequest[keys.INCOME_BENEFIT_RIDER] = "";
        }
        break;

      case keys.PWB_RIDER:
        if (value) {
          biRequest[keys.PWB_RIDER] = "1";
          biRequest.PWB = "" + value;
        } else {
          biRequest[keys.PWB_RIDER] = "";
        }
        break;

      case keys.HOSPITALITY_CASH_BENEFIT_RIDER:
        if (value) {
          biRequest[keys.HOSPITALITY_CASH_BENEFIT_RIDER] = value;
        } else {
          biRequest[keys.HOSPITALITY_CASH_BENEFIT_RIDER] = "";
        }
        break;

      case keys.FAMILY_BENEFIT_INCOME_OPTION:
        biRequest[keys.FAMILY_BENEFIT_INCOME_OPTION] = value;
        break;

      case keys.INCOME_BENEFIT_PAYOUT_FREQUENCY:
        biRequest[keys.INCOME_BENEFIT_PAYOUT_FREQUENCY] = value;
        let targetAmount = Number(biRequest?.TargetAmount);

        break;

      case keys.INCOME_BENEFIT_PAYOUT_TYPE:
        biRequest[keys.INCOME_BENEFIT_PAYOUT_TYPE] = value;
        break;

      case keys.INCOME_BENEFIT_DURATION:
        biRequest[keys.INCOME_BENEFIT_DURATION] = value;
        break;
    }
    OptimizationStore.updateBiRequestForComapareProduct(
      package_id,
      biRequest,
      productData.data.family_product_id,
      key,
      value
    )
  };

  getAdbList = () => {
    let list = [];
    for (let index = 0; index <= 100; index = index + 5) {
      if (index != 100) {
        list.push({
          id: index == 0 ? 1 : index,
          label: (index == 0 ? 1 : index) + " L",
        });
      } else {
        list.push({
          id: index,
          label: 1 + " Cr.",
        });
      }
    }
    return list;
  };

  getAtpdList = () => {
    return this.benefitAmountList(100000, 1000000);
  };

  getCriticalIllnessList = () => {
    return this.benefitAmountList(100000, 500000);
  };

  benefitAmountList = (min, max) => {
    let values = [];

    max = Math.round(max / 100000);
    for (let i = 1; i <= max; i++) {
      values.push({ id: i, label: i + " L" });
    }
    return values;
  };

  newPolicyTimeLineData(element, inputString, index, productName, finalYearIndex) {
    const { DEATH_BENEFIT, INCOME_BEN_PAY_OUT, ANN_PREM_YEARLY, MATURITY_BEN } = element;

    let data = {
      youPay: Math.round(ANN_PREM_YEARLY),
      youGet: Math.round(INCOME_BEN_PAY_OUT) + Math.round(MATURITY_BEN),
      lifeCover: Math.round(DEATH_BENEFIT),
    };

    return data;
  }

  getPolicyTermList = (age, LumpsumBenefit, formRef) => {

    let pptList = []
    if (Number(LumpsumBenefit) === 1) {
      if (Number(age) <= 55) {
        pptList = [
          { label: '5', id: '5' },
          { label: '8', id: '8' },
          { label: '10', id: '10' },
          { label: '12', id: '12' },
        ]
      }
      if (Number(age) > 55 && Number(age) <= 65) {
        pptList = [
          { label: '8', id: '8' },
          { label: '10', id: '10' },
          { label: '12', id: '12' },
        ]
      }
    } else {
      if (Number(age) <= 50) {
        pptList = [
          { label: '5', id: '5' },
          { label: '8', id: '8' },
          { label: '10', id: '10' },
          { label: '12', id: '12' },
        ]
      }
      if (Number(age) > 50 && Number(age) <= 65) {
        pptList = [
          { label: '8', id: '8' },
          { label: '10', id: '10' },
          { label: '12', id: '12' },
        ]
      }
    }

    formRef.$("PPT").set("extra", {
      ...formRef.$("PPT").extra,
      optionList: pptList,
    });
  }
}


export default new Utils();